var exports = {
  "kL": "x127c5a35--a1dc19--container",
  "Im": "x127c5a35--a1dc19--comment",
  "hc": "x127c5a35--a1dc19--edit",
};

module.exports = exports;
